import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StaffAccountingApiResponse } from "../model/accounting-api.model";
import { StaffExpenseCategoryResponse } from "../model/expense-category.model";
import { BASE_PATH } from "../variables";

@Injectable({ providedIn: "root" })
export class StaffExpenseCategoriesService {
  private readonly url: string;

  constructor(private readonly http: HttpClient, @Inject(BASE_PATH) basePath: string) {
    this.url = `${basePath.replace(/\/$/, "")}/api/v1/catalogs/expense-categories`;
  }

  list(companyId?: number): Observable<StaffAccountingApiResponse<StaffExpenseCategoryResponse[]>> {
    const params = companyId ? new HttpParams().set("companyId", companyId) : undefined;
    return this.http.get<StaffAccountingApiResponse<StaffExpenseCategoryResponse[]>>(this.url, { params });
  }
}
